import { Http } from '@/lib/http';
export class AccountTrendSettings extends Http {
  constructor() {
    super();
    this.endpoint = 'onboarder/settings/account-trends/';
  }
  getTrends() {
    return this.httpClient().get(`${this.endpoint}`);
  }
  updateTrends(payload) {
    return this.httpClient().patch(`${this.endpoint}${payload.id}`, payload);
  }
}
